import {
    useBannerStack,
    isActionBanner,
    isImageBanner
} from '../../../../../hooks/useBannerDisplay'
import { ImageBanner } from '../ImageBanner'
import { ActionBanner } from '../ActionBanner'
import {
    useAppDispatch,
    useAppSelector,
    useBanners,
    addClosedAnnouncement
} from '@thriveglobal/thrive-web-core'
import { AlertProps, ButtonProps, SxProps } from '@mui/material'

export const FeaturedBanner = ({
    imageSx,
    buttonProps,
    alertProps
}: {
    imageSx?: SxProps
    buttonProps?: ButtonProps
    alertProps?: AlertProps
}) => {
    const dispatch = useAppDispatch()
    const closedAnnouncements = useAppSelector(
        (state) => state.announcement.closedAnnouncements
    )
    const { topBanner } = useBannerStack({ banners: useBanners() })
    const handleCloseBanner = () => {
        if (!topBanner?.uuid) return
        dispatch(addClosedAnnouncement(topBanner?.uuid ?? ''))
    }

    if (!topBanner || closedAnnouncements[topBanner?.uuid ?? '']) return <></>

    if (isActionBanner(topBanner))
        return (
            <ActionBanner
                alertProps={alertProps}
                buttonProps={buttonProps}
                imageSx={imageSx}
                onClose={handleCloseBanner}
                banner={topBanner}
            />
        )
    else if (isImageBanner(topBanner))
        return (
            <ImageBanner
                src={topBanner.image?.url ?? ''}
                alt={topBanner.image?.alternativeText ?? ''}
            />
        )
    else return <></>
}
